import { ScrollArea } from '@neo/primitives/scroll-area'
import { useEvalStore } from '../store'
import { EvalEntryRenderer } from './eval-entry-renderer'

export const EvalInterface = () => {
  const events = useEvalStore((state) => state.events)

  if (events.length === 0) {
    return (
      <div className="flex-1">
        <div className="flex items-center justify-center h-full text-muted-foreground">
          No simulation events to display
        </div>
      </div>
    )
  }

  return (
    <ScrollArea className="flex-1">
      <div className="space-y-3 pb-4">
        {events.map((entry) => (
          <EvalEntryRenderer key={entry.id} entry={entry} />
        ))}
      </div>
    </ScrollArea>
  )
}
